import i18n from "@/i18n";

export const t = (key, params) => {
  return i18n.global.t(key, params);
};

export const te = (key) => {
  return i18n.global.te(key);
};

export const getLocale = () => {
  return i18n.global.locale.value;
};

export const setLocale = (lang) => {
  i18n.global.locale.value = lang;
};

export default { t, te, getLocale, setLocale };
